export function groupByMonth(entries, dateField = 'date') {
  const groups = {};
  entries.forEach(entry => {
    const date = new Date(entry[dateField]);
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    const label = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
    if (!groups[key]) {
      groups[key] = { key, label, entries: [] };
    }
    groups[key].entries.push(entry);
  });
  return Object.values(groups).sort((a, b) => b.key.localeCompare(a.key));
}
